<template>
    <div class="diagnostico contenido">
        <div class="container">
            <HelloWorld msg="Diagnóstico"
                idea="Con éste diagnóstico podrás identificar las oportunidades para minimizar el incremento anual en el gasto de seguro de gastos médicos colectivo."
                :imagen="imagen" />
            <FotoTextoLanding2 id="Reestructura" titulo="Minimiza el incremento anual de tu póliza:"
                texto="Con éste diagnóstico podrás identificar las oportunidades para minimizar el incremento anual en al gasto de seguro de gastos médicos colectivo.<br /><br />Podremos darte las principales recomendaciones para que puedas cumplir con las autoridades y tus colaboradores.<br /><br />Estrategias para que tus colaboradores se reintegren rápidamente después de un evento y más.<br /><br />Te invito a llenar este diagnóstico para darte nuestras principales recomendaciones."
                linkURL="https://forms.gle/Ak7T1dXUYfKKgSvi6" :imagen="imagen3" pos="fotoizquierda"></FotoTextoLanding2>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import Imagen from "@/assets/images/banner-landingpage-campaign01-fase02-01aquiestamosdenuevo.jpg";
import FotoTextoLanding2 from "@/components/FotoTextoLanding2.vue";
import Imagen2 from "@/assets/images/pageinteriors_individuos-y-familias-01autos.jpg";
import Imagen3 from "@/assets/images/landingpage_campaign01-fase02-01reestructurar.jpg";
import Imagen4 from "@/assets/images/landingpage_campaign01-fase02-02proteccionhogar.jpg";
import Imagen5 from "@/assets/images/landingpage_campaign01-fase02-03proteccionauto.jpg";
export default {
    name: "Individuos-y-familias",
    data() {
        return {
            imagen: Imagen,
            imagen2: Imagen2,
            imagen3: Imagen3,
            imagen4: Imagen4,
            imagen5: Imagen5
        };
    },
    components: {
        HelloWorld,
        FotoTextoLanding2
    },
    methods: {
        cambiaImagen: function (imagen) {
            this.$store.commit("cambiaImagen", imagen);
        },
        muestraFooter: function () {
            this.$store.commit("muestraFooter");
        },
        anchorHashCheck() {
            console.log(window.location.hash);
            if (window.location.hash) {
                console.log("ENTRO");
                setTimeout(function () {
                    document
                        .getElementById(window.location.hash.replace("#", ""))
                        .scrollIntoView();
                }, 500);
            }
        }
    },
    mounted: function () {
        console.log(Imagen);
        this.cambiaImagen(Imagen);
        this.muestraFooter();
        this.$store.commit("mideMenos", false);
        this.$store.commit("mideMas", false);
        this.$store.commit("estira", false);
        this.$store.commit("ocultaFooter");
        this.anchorHashCheck();
    }
};
</script>
<style scoped>
.fondoGris,
.modificaTriangulo {
    background-color: #f2f2f2;
}

.fondoGris {
    background-image: url(../assets/images/background-textura-01masbeneficios.png);
    background-size: auto;
    background-position: left bottom;
    background-repeat: no-repeat;
}

.grisSombra {
    background: #d9f6ff;
    box-shadow: 10px 10px 0 #000;
    border: 3px solid #1900ff;
}

.contenido {
    min-height: 500px;
}

@media only screen and (max-width: 1199px) {}
</style>
<style>
.modificaTriangulo .triangulo {
    margin-top: 0 !important;
}

.grisSombra .btn-primary {
    background-color: #d9f6ff !important;
}

.fondoGris .btn-primary {
    background-color: #f2f2f2 !important;
}
</style>
